import api from './api';

/**
 * Query params for a server-paged admin list. Drops empty values and the "all" sentinel the
 * filter toggles use, so the request is just `?page=0&size=20&search=x&sort=name,asc&active=inactive`.
 */
export const toPageParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== 'all' && v !== 'ALL')
  );

/** GET `${url}` as a Spring Page: { content, totalElements, totalPages, number, size, ... }. */
export const fetchPage = async (url, params) => (await api.get(url, { params: toPageParams(params) })).data;
